exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media screen and (max-width: 1050px){\n.score-card[data-v-46d3a584]{padding-right:4rem !important;padding-left:4rem !important\n}\n}\n.section[data-v-46d3a584]{width:100%\n}\n.section.bg-green[data-v-46d3a584]{background:#869740\n}\n.section.bg-green>.section-title[data-v-46d3a584]{color:#fff\n}\n@media screen and (max-width: 1050px){\n.section.featured-project[data-v-46d3a584]{padding-right:4rem !important;padding-left:4rem !important\n}\n}", ""]);

// exports
